import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import AgGridTable from "../components/ui/AgGridTable";
import { ColDef } from "ag-grid-community";
import { Edit, Search } from "lucide-react";
import { Input } from "../components/ui/input";

const Data = [
  {
    id: 1,
    key: "user_name",
    english: "Username",
    arabic: "asm aalmustakhdam",
  },
  {
    id: 2,
    key: "user_name",
    english: "Username",
    arabic: "asm aalmustakhdam",
  },
  {
    id: 3,
    key: "user_name",
    english: "Username",
    arabic: "asm aalmustakhdam",
  },
  {
    id: 4,
    key: "user_name",
    english: "Username",
    arabic: "asm aalmustakhdam",
  },
];

const Users = () => {
  const [search, setSearch] = useState("");

  const filteredData = useMemo(() => {
    if (!search.trim()) return Data;
    const lower = search.toLowerCase();
    return Data.filter(
      (item) =>
        item.key.toLowerCase().includes(lower) ||
        item.english.toLowerCase().includes(lower) ||
        item.arabic.toLowerCase().includes(lower)
    );
  }, [search]);

  const columnDefs = useMemo<ColDef[]>(() => {
    return [
      {
        headerName: "Sr No.",
        field: "id",
        minWidth: 70,
        width: 80,
      },
      {
        headerName: "Key",
        field: "key",
        minWidth: 150,
        width: 180,
      },
      {
        headerName: "English String",
        field: "english",
        minWidth: 200,
        flex: 1.5,
      },
      {
        headerName: "Arabic String",
        field: "arabic",
        minWidth: 200,
        flex: 1.5,
      },
      {
        headerName: "Action",
        field: "id",
        minWidth: 90,
        width: 100,
        cellRenderer: (p: any) => {
          return (
            <Link
              to={`/language/edit/${p.value}`}
              className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md text-xs font-semibold bg-slate-50 hover:bg-slate-100 text-slate-700 border border-slate-200 transition-colors"
            >
              <Edit className="w-3.5 h-3.5" />
              <span>Edit</span>
            </Link>
          );
        },
      },
    ];
  }, []);

  return (
    <>
      <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
        <div className="relative w-64 sm:w-72">
          <Search className="w-4 h-4 text-slate-400 absolute left-2.5 top-1/2 -translate-y-1/2 pointer-events-none" />
          <Input
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search language strings..."
            className="search-icon-input h-9 text-sm bg-white border-slate-200 focus:bg-white shadow-2xs"
          />
        </div>
      </div>

      <AgGridTable
        rowData={filteredData}
        columnDefs={columnDefs}
        domLayout="autoHeight"
        emptyMessage="No language strings found"
      />
    </>
  );
};

export default Users;
